import {
	CONTRACT_NO,
	STATUS,
	ASSET_NUMBER,
	CATEGORY,
	DESCRIPTION,
	MANUFACTURER,
	MODEL_NO,
	SERIAL_NO,
	END_OF_TERM_OPTION,
	TOTAL_FINANCED,
	SUPPLIER_NAME,
	ADDRESS_LINE_1,
	CITY,
	COUNTY,
	ADDRESS_LINE_2,
	ADDRESS_LINE_3,
	ADDRESS_LINE_4,
	POSTAL_CODE,
	STATE,
	COUNTRY,
	PURCHASE_ORDER_NO,
	SUPPLIER_INVOICE_NO,
	RETURNED_DATE,
	ASSET_TERMINATION_TYPE,
	ASSET_TERMINATION_DATE,
	RELEASE_CONTRACT_NO,
	NON_LEASED_ASSET_SPEC,
	NON_LEASED_CUSTOMER_ATTRIBUTES,
	NON_LEASED_ASSET_LOCATION,
	NON_LEASED_LEASE_DETAILS,
	SCHEDULE_NO,
	TERM_HEADER,
	SUPPLIER_INVOICE_DATE
} from '../../../constants/messages.tsx';


export interface AssetDetailLabels {
	field: string;
	headerName: string;
	currency?: boolean;
	date?: boolean;
}

// Non-Leased Asset Modal Section Names
export const nonLeasedAssetSpec = NON_LEASED_ASSET_SPEC;
export const nonLeasedCustomerAttributes = NON_LEASED_CUSTOMER_ATTRIBUTES;
export const nonLeasedAssetLocation = NON_LEASED_ASSET_LOCATION;
export const nonLeasedLeaseDetails = NON_LEASED_LEASE_DETAILS;

// Non-Leased Asset Specifications
export const nonLeasedAssetSpecsColumns: AssetDetailLabels[] = [
	{ field: 'assetNumber', headerName: ASSET_NUMBER },
	{ field: 'assetCategory', headerName: CATEGORY },
	{ field: 'manufacturer', headerName: MANUFACTURER },
	{ field: 'modelNumber', headerName: MODEL_NO },
	{ field: 'serialNumber', headerName: SERIAL_NO },
	{ field: 'itemDescription', headerName: DESCRIPTION },
	{ field: 'scheduleNo', headerName: SCHEDULE_NO },
	{ field: 'term', headerName: TERM_HEADER },
	{ field: 'startDate', headerName: 'Start Date', date: true },
	{ field: 'endDate', headerName: 'End Date', date: true },
];

// Non-Leased Asset Location columns (using equipment location fields)
export const nonLeasedAssetLocationColumns: AssetDetailLabels[] = [
	{ field: 'eqLocationAddress1', headerName: ADDRESS_LINE_1 },
	{ field: 'eqLocationAddress2', headerName: ADDRESS_LINE_2 },
	{ field: 'eqLocationAddress3', headerName: ADDRESS_LINE_3 },
	{ field: 'eqLocationAddress4', headerName: ADDRESS_LINE_4 },
	{ field: 'eqLocationCity', headerName: CITY },
	{ field: 'eqLocationCounty', headerName: COUNTY },
	{ field: 'eqLocationState', headerName: STATE },
	{ field: 'eqLocationZipCode', headerName: POSTAL_CODE },
	{ field: 'eqLocationCountry', headerName: COUNTRY },
];

// Non-Leased Lease Details columns
export const nonLeasedLeaseDetailsColumns: AssetDetailLabels[] = [
	{ field: 'purchasePrice', headerName: TOTAL_FINANCED, currency: true },
	{ field: 'purchaseOrderNo', headerName: PURCHASE_ORDER_NO },
	{ field: 'supplierName', headerName: SUPPLIER_NAME },
	{ field: 'supplierInvoiceNo', headerName: SUPPLIER_INVOICE_NO },
	{ field: 'supplierInvoiceDate', headerName: SUPPLIER_INVOICE_DATE, date: true },
];

// Non-Leased Customer Attributes (UDFs will be appended dynamically)
export const nonLeasedCustomerAttributesColumns: AssetDetailLabels[] = [
	// UDFs will be added in the modal using the same approach as leased assets
];

export const assetSpec: string = 'Asset Specifications';
export const customerAttributes: string = 'Customer Attributes';
export const assetLocation: string = 'Asset Location';
export const leaseDetails: string = 'Lease Details';

// Asset Specifications attributes
export const assetSpecsColumns: AssetDetailLabels[] = [
	{ field: 'assetNumber', headerName: ASSET_NUMBER },
	{ field: 'assetStatus', headerName: STATUS },
	{ field: 'assetCategory', headerName: CATEGORY },
	{ field: 'make', headerName: MANUFACTURER },
	{ field: 'model', headerName: MODEL_NO },
	{ field: 'serialNumber', headerName: SERIAL_NO },
	{ field: 'itemDescription', headerName: DESCRIPTION },
	{ field: 'contract_contractNumber', headerName: CONTRACT_NO },
	{ field: 'origAssetNumber', headerName: 'Original Asset No.' },
	{ field: 'splitDate', headerName: 'Split Date', date: true },
];

// Asset Location columns
export const assetLocationColumns: AssetDetailLabels[] = [
	{ field: 'installAddress1', headerName: ADDRESS_LINE_1 },
	{ field: 'installAddress2', headerName: ADDRESS_LINE_2 },
	{ field: 'installAddress3', headerName: ADDRESS_LINE_3 },
	{ field: 'installAddress4', headerName: ADDRESS_LINE_4 },
	{ field: 'installCity', headerName: CITY },
	{ field: 'installCounty', headerName: COUNTY },
	{ field: 'installState', headerName: STATE },
	{ field: 'installPostalCode', headerName: POSTAL_CODE },
	{ field: 'installCountry', headerName: COUNTRY },
];

// Lease Details columns
export const leaseDetailsColumns: AssetDetailLabels[] = [
	{ field: 'contract_eotOption', headerName: END_OF_TERM_OPTION },
	{ field: 'purchasePrice', headerName: TOTAL_FINANCED, currency: true },
	{ field: 'purchaseOrder', headerName: PURCHASE_ORDER_NO },
	{ field: 'supplierName', headerName: SUPPLIER_NAME },
	{ field: 'supplierInvoiceNo', headerName: SUPPLIER_INVOICE_NO },
	{ field: 'dateReturned', headerName: RETURNED_DATE, date: true },
	{ field: 'terminationType', headerName: ASSET_TERMINATION_TYPE },
	{ field: 'dateTerminated', headerName: ASSET_TERMINATION_DATE, date: true },
	{ field: 'releaseSchedule', headerName: RELEASE_CONTRACT_NO },
];
